// Stop navigation from product-card link, but keep qty buttons working
document.addEventListener('click', function (e) {
  if (
    e.target.closest('.quantity-selector') ||
    e.target.closest('quantity-selector-component') ||
    e.target.closest('.qty-guard')
  ) {
    // DO NOT preventDefault, just stop bubbling so the parent <a> doesn't see it
    e.stopPropagation();
  }
}, false); // bubble phase so target handlers still run
